// eslint-disable-next-line import/prefer-default-export

import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

/**
 * Build options for flexdropdowns (users/customers)
 *
 * @param {object} data
 * @returns {array}
 */
const buildOptions = (data) => {
  const errored = get(data, '0.code');

  if (!data || (data && data.length) || errored) {
    return [];
  }

  const codes = Object.keys(data);
  const names = Object.values(data);
  const options = [];

  // map options
  codes.forEach((c, k) => {
    options.push({
      id: k + 1,
      name: `${c} - ${names[k]}`,
      code: c,
      value: data[c]
    });
  });

  return sortBy(options, (o) => o.name);
};

/**
 * Prepare a collection of customers to be used in dropdown
 *
 * @param {object} customers
 * @returns {array}
 */
export const buildCustomers = buildOptions;

/**
 * Prepare a collection of users to be used in dropdown
 *
 * @param {object} users
 * @returns {array}
 */
export const buildUsers = buildOptions;
